/* file description */
import { ExclamationCircleOutlined } from '@ant-design/icons';
import useMetaStore from '@/store/useMetaStore';
import { Modal, message } from 'antd';
import React from 'react';
import { deleteAssetCascadeData } from '@/api/cascade';
import { Api } from '@/utils';

const { confirm } = Modal;

export const useClick = () => {
  const sotreState = useMetaStore((state) => state);
  const { taskId, recordId, utils, pageConfig, taskInfo } = sotreState;
  const urlVersion = utils?.queryParams?.version;
  const urlOpenVersion = utils?.queryParams?.openVersion === 'true' ? true : undefined;
  const editClick = () => {
    const urlParams = urlOpenVersion ? `?version=${urlVersion || '1'}&openVersion=${urlOpenVersion}` : '';
    utils?.buiNavigate({
      type: 'spa',
      path: `/lcp/task/${taskId}/edit/${recordId}${urlParams}`,
    });
  };
  // 任务中心：提交审批按钮后修改任务状态
  const changeStatusClick = () => {
    if (Boolean(utils?.queryParams?.taskId) && Boolean(utils?.queryParams?.operatorId)) {
      const operatorId = utils?.queryParams?.operatorId;
      const taskId = utils?.queryParams?.taskId;
      const url = `/api/gateway/todoservice/users/${operatorId}/task/${taskId}/status?operatorId=${operatorId}`;
      Api({
        method: 'put',
        url,
      });
    }
  };
  const copyClick = () => {
    utils?.buiNavigate({
      type: 'tab',
      path: `/lcp/task/${taskId}/create?TAB_KEY=${new Date().getTime()}&copyId=${recordId}&copyName=${pageConfig.detailPageConfig?.copyName}`,
    });
  };
  const closeClick = () => {
    const urlParams = urlOpenVersion ? `?openVersion=${urlOpenVersion}` : '';
    utils?.buiNavigate({
      type: 'closeTab',
      path: `/lcp/task/${taskId}/list${urlParams}`,
    });
    utils?.saveSuccess && utils?.saveSuccess(null);
  };

  // 删除按钮
  const deleteClick = async () => {
    const mainModuleCode = taskInfo.modules.find((module: any) => module.moduleID === taskInfo.mainModuleId)?.handle;
    confirm({
      title: '确定要删除这条数据吗?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteAssetCascadeData({
          modelId: mainModuleCode,
          recordId,
          taskId,
        }).then((res) => {
          if (res?.success) {
            if (!res.data) {
              message.error('返回结构错误');
              return;
            }
            utils?.buiNavigate && utils?.buiNavigate({
              type: 'closeTab',
            });
            message.success('删除成功');
          } else {
            message.error('保存失败');
          }
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };


  return {
    editClick,
    changeStatusClick,
    copyClick,
    closeClick,
    deleteClick,
  };
};
